import { render, staticRenderFns } from "./UserService.vue?vue&type=template&id=7a60e652&scoped=true&"
import script from "./UserService.vue?vue&type=script&lang=js&"
export * from "./UserService.vue?vue&type=script&lang=js&"
import style0 from "./UserService.vue?vue&type=style&index=0&id=7a60e652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a60e652",
  null
  
)

export default component.exports